import enUS from "@/i18n/en_US";
import ptBR from "@/i18n/pt_BR";
import esES from "@/i18n/es_ES";
import { CES_LIKERT_5, CES_LIKERT_7, CES_TEXTUAL_5, CES_TEXTUAL_7, CSAT_LIKERT, QUESTION_TYPE } from "../consts/survey";

/**
 * The colors array for the different scales
 */
const colors = {
  colors010: [
    "#b72124",
    "#d62027",
    "#ef5222",
    "#f46f21",
    "#faa822",
    "#ffca26",
    "#ecdb11",
    "#dedd37",
    "#c5d92d",
    "#afd136",
    "#65b54d"
  ],
  colors110: [
    "#d62027",
    "#ef5222",
    "#f46f21",
    "#faa822",
    "#ffca26",
    "#ecdb11",
    "#dedd37",
    "#c5d92d",
    "#afd136",
    "#65b54d"
  ],
  colors17: ["#a80b1e", "#f2243d", "#f5a623", "#fdc33e", "#c7d153", "#2acf65", "#15aa4a"],
  colors05: ["#a80b1e", "#f2243d", "#f46f21", "#f5a623", "#2acf65", "#15aa4a"],
  colors15: ["#a80b1e", "#f2243d", "#f5a623", "#2acf65", "#15aa4a"]
};
/**
 * The likert values for the different scales
 */
const likertValues = {
  likert_csat: [
    { value: CSAT_LIKERT.EXTREMELY_UNSATISFIED, label: "extremely_unsatistied" },
    { value: CSAT_LIKERT.UNSATISFIED, label: "unsatisfied" },
    { value: CSAT_LIKERT.NEUTRAL, label: "neutral" },
    { value: CSAT_LIKERT.SATISFIED, label: "satisfied" },
    { value: CSAT_LIKERT.EXTREMELY_SATISFIED, label: "extremely_satistied" }
  ],
  likert_5: [
    { value: CES_LIKERT_5.STRONGLY_DISAGREE, label: "strongly_disagree" },
    { value: CES_LIKERT_5.DISAGREE, label: "disagree" },
    { value: CES_LIKERT_5.NEUTRAL, label: "neutral" },
    { value: CES_LIKERT_5.AGREE, label: "agree" },
    { value: CES_LIKERT_5.STRONGLY_AGREE, label: "strongly_agree" }
  ],
  likert_7: [
    { value: CES_LIKERT_7.STRONGLY_DISAGREE, label: "strongly_disagree" },
    { value: CES_LIKERT_7.DISAGREE, label: "disagree" },
    { value: CES_LIKERT_7.SOMEWHAT_DISAGREE, label: "somewhat_disagree" },
    { value: CES_LIKERT_7.NEUTRAL, label: "neutral" },
    { value: CES_LIKERT_7.SOMEWHAT_AGREE, label: "somewhat_agree" },
    { value: CES_LIKERT_7.AGREE, label: "agree" },
    { value: CES_LIKERT_7.STRONGLY_AGREE, label: "strongly_agree" }
  ]
};

const textualValues = {
  5: [
    { value: CES_TEXTUAL_5.VERY_HARD, label: "very_hard" },
    { value: CES_TEXTUAL_5.HARD, label: "hard" },
    { value: CES_TEXTUAL_5.NEUTRAL, label: "neutral" },
    { value: CES_TEXTUAL_5.EASY, label: "easy" },
    { value: CES_TEXTUAL_5.VERY_EASY, label: "very_easy" }
  ],
  7: [
    { value: CES_TEXTUAL_7.EXTREMELY_HARD, label: "extremely_hard" },
    { value: CES_TEXTUAL_7.VERY_HARD, label: "very_hard" },
    { value: CES_TEXTUAL_7.HARD, label: "hard" },
    { value: CES_TEXTUAL_7.NEUTRAL, label: "neutral" },
    { value: CES_TEXTUAL_7.EASY, label: "easy" },
    { value: CES_TEXTUAL_7.VERY_EASY, label: "very_easy" },
    { value: CES_TEXTUAL_7.EXTREMELY_EASY, label: "extremely_easy" }
  ]
};

export const optionOtherLabel = {
  en_US: enUS.survey.new.other,
  pt_BR: ptBR.survey.new.other,
  es_ES: esES.survey.new.other
};

export const commentPlaceholder = {
  en_US: enUS.survey.new.placeholder_comment,
  pt_BR: ptBR.survey.new.placeholder_comment,
  es_ES: esES.survey.new.placeholder_comment
};

export const openQuestionPlaceholder = {
  en_US: enUS.survey.new.placeholder_openquestion,
  pt_BR: ptBR.survey.new.placeholder_openquestion,
  es_ES: esES.survey.new.placeholder_openquestion
};

/**
 * Get the i18n translations to all the survey languages
 * to display the language equal the language of the survey
 * @param {the array of likert values} likertValues
 */
function getLikertLabels(likertValues) {
  const newValues = JSON.parse(JSON.stringify(likertValues));
  newValues.map((likert) => {
    likert.label = {
      en_US: enUS.survey.likert[likert.label],
      pt_BR: ptBR.survey.likert[likert.label],
      es_ES: esES.survey.likert[likert.label]
    };
  });
  return newValues;
}

/**
 * Get the i18n translations to all the survey languages
 * to display the language equal the language of the survey
 * @param {the array of textual values} textualValues
 */
function getTextualLabels(textualValues) {
  const newValues = JSON.parse(JSON.stringify(textualValues));
  newValues.map((likert) => {
    likert.label = {
      en_US: enUS.survey.textual[likert.label],
      pt_BR: ptBR.survey.textual[likert.label],
      es_ES: esES.survey.textual[likert.label]
    };
  });
  return newValues;
}

export const multipleChoiceLetters = {
  0: "A",
  1: "B",
  2: "C",
  3: "D",
  4: "E",
  5: "F",
  6: "G",
  7: "H",
  8: "I",
  9: "J",
  10: "K",
  11: "L",
  12: "M",
  13: "N",
  14: "O",
  15: "P",
  16: "Q",
  17: "R",
  18: "S",
  19: "T",
  20: "U",
  21: "V",
  22: "X",
  23: "Z"
};

/**
 * Get the scale array for the question, number , likert or inverted
 * @param {min_scale} minScale
 * @param {max_scale} maxScale
 * @param {inverted_scale} reverse
 * @param {scale_type} scaleType
 * @param {the type of the question item} questionType
 */
export function getScale(minScale, maxScale, reverse, scaleType, questionType) {
  let scaleArray = [];
  if (scaleType === 0) {
    for (let i = minScale; i <= maxScale; i++) {
      scaleArray.push(i);
    }
    if (reverse) {
      scaleArray = revert(scaleArray);
    }
  } else if (scaleType === 2) {
    scaleArray = getTextualScale(maxScale);
  } else {
    scaleArray = getLikertScale(questionType, maxScale);
  }

  return scaleArray;
}
/**
 * Get scale array based on likert questions
 * @param {the question type(CES of CSAT)} questionType
 * @param {max_scale} maxScale
 */
export function getLikertScale(questionType, maxScale) {
  let likertScale = [];
  if (questionType === QUESTION_TYPE.CES || questionType === QUESTION_TYPE.CES2) {
    if (maxScale === 7) {
      likertScale = [...likertValues.likert_7];
    } else {
      likertScale = [...likertValues.likert_5];
    }
  } else {
    likertScale = [...likertValues.likert_csat];
  }

  return getLikertLabels(likertScale);
}

/**
 * Get scale array based on textual questions
 * @param {The max scale to know what labels to use} maxScale
 */
export function getTextualScale(maxScale) {
  let textualScale = [...textualValues[maxScale]];

  return getTextualLabels(textualScale);
}

/**
 * Return if the question button is filled with background or bordered
 * @param {button_design} buttonDesign
 */
export function isFilled(buttonDesign) {
  return !!(buttonDesign === 1 || buttonDesign === 3);
}
/**
 * Return the radius of the question button according scale type and button design
 * @param {button_design} buttonDesign
 * @param {scale_type} scaleType
 */
export function roundedValue(buttonDesign, scaleType) {
  return buttonDesign === 1 || buttonDesign === 2 || scaleType === 1 ? "1.5px" : "100%";
}
/**
 * Get button color based on index and color pattern
 * @param {the index of the button in the array} index
 * @param {color_pattern} colorPatern
 * @param {the colors array based on scale} colors
 * @param {custom_color chosed by user} customColor
 */
export function getColor(index, colorPatern, colors, customColor) {
  if (colorPatern === 1) {
    return colors[index]; // Track standard
  }
  if (colorPatern === 2) {
    return "#aaabb3"; // Gray scale
  }
  return customColor; // Custom
}

/**
 * Get track standard array of colors based on scale
 * @param {min_scale} minScale
 * @param {max_scale} maxScale
 * @param {inverted_scale} reverse
 */
export function getColorsArray(minScale, maxScale, reverse) {
  const min = minScale;
  const max = maxScale;
  let colorArray = [];
  if (min === 0 && max === 10) {
    colorArray = colors.colors010;
  } else if (min === 1 && max === 10) {
    colorArray = colors.colors110;
  } else if (min === 1 && max === 7) {
    colorArray = colors.colors17;
  } else if (min === 0 && max === 5) {
    colorArray = colors.colors05;
  } else {
    colorArray = colors.colors15;
  }
  if (reverse) {
    colorArray = revert(colorArray);
  }
  return colorArray;
}

function revert(array) {
  return array.slice().reverse();
}

export function getCes2Question(scaleType) {
  if (scaleType === 1) {
    return {
      en_US: enUS.survey.new.ces2_question_likert,
      pt_BR: ptBR.survey.new.ces2_question_likert,
      es_ES: esES.survey.new.ces2_question_likert
    };
  }
  return {
    en_US: enUS.survey.new.ces2_question,
    pt_BR: ptBR.survey.new.ces2_question,
    es_ES: esES.survey.new.ces2_question
  };
}

/**
 * Method that return button scale based on max scale (very hard or extremely)
 * @param {question max scale} maxScale
 */
export function getCes2MinButtonScale(maxScale) {
  if (maxScale === 5) {
    return {
      en_US: enUS.survey.textual.very_hard,
      pt_BR: ptBR.survey.textual.very_hard,
      es_ES: esES.survey.textual.very_hard
    };
  }
  return {
    en_US: enUS.survey.textual.extremely_hard,
    pt_BR: ptBR.survey.textual.extremely_hard,
    es_ES: esES.survey.textual.extremely_hard
  };
}

/**
 * Method that return button scale based on max scale (very easy or extremely)
 * @param {question max scale} maxScale
 */
export function getCes2MaxButtonScale(maxScale) {
  if (maxScale === 5) {
    return {
      en_US: enUS.survey.textual.very_easy,
      pt_BR: ptBR.survey.textual.very_easy,
      es_ES: esES.survey.textual.very_easy
    };
  }
  return {
    en_US: enUS.survey.textual.extremely_easy,
    pt_BR: ptBR.survey.textual.extremely_easy,
    es_ES: esES.survey.textual.extremely_easy
  };
}
